/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureEonApplication {
  /**
  * The Azure application (client) ID for the Eon application registration
  */
  'applicationId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return AzureEonApplication.attributeTypeMap;
  }

  public constructor() {
  }
}

